/* eslint-disable max-len */

import React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

function SmallDownload(props: SvgIconProps): React.ReactElement {
  return (
    <SvgIcon viewBox="0 0 16 16" {...props}>
      <path
        d="M5774,6079a1,1,0,0,1,0-2h10a1,1,0,0,1,0,2Zm5-4.046a1,1,0,0,1-.706-.293l-4.243-4.243a1,1,0,0,1,1.413-1.414l2.537,2.537V6066a1,1,0,1,1,2,0v5.54l2.536-2.536a1,1,0,0,1,1.414,1.414l-4.243,4.243a1,1,0,0,1-.707.293Z"
        transform="translate(-5771 -6064)"
      />
    </SvgIcon>
  );
}

export default SmallDownload;
